import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const InPlayIcon = observer('InPlayIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
            className={className}
            onClick={onClick}
        >
            <path
                fill='#FFFFFF'
                fillRule='evenodd'
                d='M10.001 3.333h-.666a.669.669 0 0 1-.667-.666c0-.367.3-.667.667-.667h5.333c.367 0 .667.3.667.667 0 .366-.3.666-.667.666H14v1.569a8.698 8.698 0 0 1 3.631 1.854L18.388 6a85.016 85.016 0 0 0-.193-.193.672.672 0 0 1 0-.947c.26-.26.686-.26.946 0l1.334 1.333c.26.26.26.68 0 .94a.682.682 0 0 1-.478.2c-.215 0-.31-.039-.665-.384l-.35.351c-.17.173-.3.303-.403.402a8.617 8.617 0 0 1 1.956 4.191c.793 4.72-2.387 9.194-7.107 9.987-.467.08-.947.12-1.42.12H12A8.666 8.666 0 0 1 7.668 5.827c.313-.2.72-.107.92.206.2.314.107.72-.207.92-.01.01-.024.017-.036.022l-.007.003-.003.002A7.341 7.341 0 0 0 5.648 17c2.02 3.513 6.507 4.707 10.02 2.687a7.341 7.341 0 0 0 2.687-10.02 7.342 7.342 0 0 0-7.512-3.577.663.663 0 0 1-.366-.005.67.67 0 0 1-.476-.518v-.014a.656.656 0 0 1 0-.216V3.333Zm1.334 0h1.333v1.359a8.65 8.65 0 0 0-1.333-.001V3.333Z'
                clipRule='evenodd'
            />
            <path
                fill='#FFFFFF'
                d='M19.997 7.333h.004-.006.002ZM11.335 13.333c0 .367.3.667.666.667.367 0 .667-.3.667-.667v-2c0-.366-.3-.666-.667-.666-.366 0-.666.3-.666.666v2Z'
            />
            <path
                fill='#141C31'
                fillRule='evenodd'
                d='M6.001 13.333a6 6 0 1 0 12.001 0 6 6 0 0 0-12 0Zm1.334 0A4.663 4.663 0 0 1 12 8.667a4.663 4.663 0 0 1 4.667 4.666A4.663 4.663 0 0 1 12 18a4.663 4.663 0 0 1-4.666-4.667Z'
                clipRule='evenodd'
            />
            <path
                fill='#39B54A'
                d='M12.001 19.333a6 6 0 1 1 .001-12 6 6 0 0 1 0 12Zm0-10.666a4.663 4.663 0 0 0-4.666 4.666A4.663 4.663 0 0 0 12 18a4.663 4.663 0 0 0 4.667-4.667 4.663 4.663 0 0 0-4.667-4.666Z'
            />
        </SvgElement>
    );
});
